import { documentStore, singularityStore, uiStore } from "@/store/store";
import { treeNodeReduce } from "@/lib/tree/tree";
import { TreeNode } from "@/types/tree";
import {
  FUTURELAYER_FOOTER_ELEMENT_TYPE,
  FUTURELAYER_HEADER_ELEMENT_TYPE,
  FUTURELAYER_SITELOGO_ELEMENT_TYPE
} from "../headers-footers/headers-footers";
import { forceNextTick } from "@/util/force-next-tick";

export async function rerenderElementsThatUseLogo() {
  await rerenderLogoElements();
  await rerenderHeaderAndFooterElements();
}

export async function rerenderHeaderAndFooterElements() {
  const headerAndFooterElementIds =
    findHeaderAndFooterElementsInCurrentDocument();
  console.log("headerAndFooterElementIds", headerAndFooterElementIds);
  await Promise.all(
    headerAndFooterElementIds.map(elementId =>
      triggerRefreshOfElement(elementId)
    )
  );
}

export async function rerenderLogoElements() {
  const logoElementIds = findSiteLogoElementsInCurrentDocument();
  console.log("logoElementIds", logoElementIds);
  await Promise.all(
    logoElementIds.map(elementId => triggerRefreshOfElement(elementId))
  );
}

function findSiteLogoElementsInCurrentDocument(): TreeNode["id"][] {
  const logoElementIds: TreeNode["id"][] = [];

  treeNodeReduce(
    (node: TreeNode, acc: TreeNode["id"][]) => {
      if (node.data.type === FUTURELAYER_SITELOGO_ELEMENT_TYPE) {
        acc.push(node.id);
      }
      return acc;
    },
    documentStore.document.tree.root,
    logoElementIds
  );

  return logoElementIds;
}

function findHeaderAndFooterElementsInCurrentDocument(): TreeNode["id"][] {
  const headerAndFooterElementIds: TreeNode["id"][] = [];
  const inlineEditingElementId = uiStore.inlineEditingContext?.elementId;

  treeNodeReduce(
    (node: TreeNode, acc: TreeNode["id"][]) => {
      if (
        (node.data.type === FUTURELAYER_HEADER_ELEMENT_TYPE ||
         node.data.type === FUTURELAYER_FOOTER_ELEMENT_TYPE) &&
        node.id !== inlineEditingElementId
      ) {
        acc.push(node.id);
      }
      return acc;
    },
    documentStore.document.tree.root,
    headerAndFooterElementIds
  );

  return headerAndFooterElementIds;
}

async function triggerRefreshOfElement(elementId: TreeNode["id"]) {
  // We force next tick so it triggers for all elements
  // If we don't, Vue will run updates in batches and only the last element will be updated.
  forceNextTick(() => {
    uiStore.setRefreshSsrElementId(elementId);
  });
}
